import { useEffect } from 'react';

import {
  type AiGenerateDockCopy,
  type AiGenerateDockRunPhase,
} from '../types/aiGenerateDock.types';
import { aiGenerateDockToasts } from '../utils/aiGenerateDockToasts';

/**
 * 생성 중 토스트를 실행 상태에 맞춘다 — 시작하면 띄우고, 단계가 바뀌면 문구만 바꾸고, 끝나면 닫는다.
 * 토스트는 _app 전역 Toaster 에 뜨므로 생성기가 숨겨지거나(채팅 패널·설정 단계) 빌드 화면을 떠나면
 * 직접 닫아야 남지 않는다. 다시 보이면 진행 중인 생성의 토스트를 다시 띄운다.
 */
export const useAiGenerateDockRunningToast = ({
  visible,
  runningCount,
  runningPhase,
  copy,
  onCancel,
}: {
  visible: boolean;
  runningCount: number | null;
  runningPhase: AiGenerateDockRunPhase | null;
  copy: Pick<AiGenerateDockCopy, 'running' | 'preparingSource' | 'cancel'>;
  onCancel: () => void;
}) => {
  // 자료 탭은 자료를 올리고 읽는 동안(생성 턴 전) 문구가 다르다.
  // 문구 객체는 렌더마다 새로 만들어지므로 효과는 완성된 문자열에만 기대게 한다.
  const title =
    !visible || runningCount === null
      ? null
      : runningPhase === 'preparing_source'
      ? copy.preparingSource
      : copy.running(runningCount);
  const cancelLabel = copy.cancel;

  useEffect(() => {
    if (title === null) {
      aiGenerateDockToasts.dismissRunning();
      return;
    }
    aiGenerateDockToasts.running(title, {
      label: cancelLabel,
      onClick: onCancel,
    });
  }, [title, cancelLabel, onCancel]);

  useEffect(() => () => aiGenerateDockToasts.dismissRunning(), []);
};
